import { PaymentActionButton, type PaymentActionButtonType, SpendingLimitBarUser } from '@components'
import CoreLoader from '@components/CoreLoader'
import { AccountsOverview } from '@dashboard/components'
import { useFeatureFlag } from '@hooks'
import { TransactionsSection } from '@views/dashboard/TransactionsSection'
import TransactionsRequiringApproval from '@views/dashboard/TransactionsSection/TransactionsRequiringApproval/TransactionsRequiringApproval'
import { paths, useMerchantAccounts, useMyAccountAccessQry } from 'mmfintech-backend-api'
import { isValidArray } from 'mmfintech-commons'
import { useEffect, useMemo, useRef } from 'react'
import { useHistory } from 'react-router-dom'

import './StaffDashboard.scss'

const StaffDashboard = () => {
  const hasTransactionApprovalFlow = useFeatureFlag('transactionApprovalFlow')
  const { paymentAccounts: accounts, accountsFetching, activeAccounts, accountsError } = useMerchantAccounts()

  const { hasAnyWritePermission, accountAccess } = useMyAccountAccessQry()

  const history = useHistory()
  const hasFetchedOnce = useRef(false)

  useEffect(() => {
    if (accountsFetching) {
      hasFetchedOnce.current = true
    }

    if (hasFetchedOnce.current && !accountsFetching && !isValidArray(accounts)) {
      history.replace(paths.expenseManagement.dashboard())
    }
  }, [accounts, accountsFetching, history])

  const staffButtons = useMemo(() => {
    const buttons: PaymentActionButtonType[] = ['deposit', 'send']
    if (hasAnyWritePermission) {
      const writerCurrencies = new Set(accountAccess?.filter(a => a.accessLevel === 'WRITER').map(a => a.currency))
      if (writerCurrencies.size >= 2) {
        buttons.push('exchange')
      }
    }
    return buttons
  }, [accountAccess, hasAnyWritePermission])

  return (
    <div className='staff-dashboard-wrapper' data-test='staff-dashboard'>
      {accountsFetching ? (
        <CoreLoader />
      ) : (
        <>
          {hasAnyWritePermission && (
            <div className='staff-dashboard-container'>
              <div className='payment-action-button-group'>
                {staffButtons.map(buttonType => (
                  <PaymentActionButton key={buttonType} type={buttonType} />
                ))}
              </div>

              {hasTransactionApprovalFlow && <TransactionsRequiringApproval className='staff-dashboard' />}

              <SpendingLimitBarUser />
            </div>
          )}

          <AccountsOverview
            activeAccounts={activeAccounts}
            accountsError={accountsError}
            accountsFetching={accountsFetching}
          />

          <TransactionsSection />
        </>
      )}
    </div>
  )
}

export default StaffDashboard
